import Icon from "@/components/base/Icon"
import useQuerySocial from "@/hooks/social/useQuerySocial"
import useResponsive from "@/hooks/use-responsive"
import SocialStore from "@/store/social"
import { SchedulerItemProps } from "@/types/scheduler"
import { Button, Stack, Typography } from "@mui/material"
import dayjs from "dayjs"
import { useCallback, useMemo, useState } from "react"

export const SocialsCampaignItem = ({ date, events }: SchedulerItemProps) => {
    const { isMobile } = useResponsive()
    const { createPost } = useQuerySocial()
    const { flushTempPost } = SocialStore()
    const [showIconAddPost, setShowIconAddPost] = useState<boolean>(false)
    const formattedDate = useMemo(() => {
        const tempDate = `${date.year}-${date.month + 1}-${date.day}`
        return dayjs(tempDate, "YYYY-M-D").format("YYYY-MM-DD")
    }, [date])

    const getData = useCallback(
        (data) => {
            if (data && data.render) {
                return data.render({ ...data.renderParams, publishAt: date })
            }
            return null
        },
        [date]
    )
    const handleShowIconAddPost = (value: boolean) => {
        setShowIconAddPost(value)
    }

    const isAfterToday = useMemo(() => {
        const day = formattedDate
        return dayjs(day, "YYYY-MM-DD").isAfter(dayjs()) || dayjs(day).isSame(dayjs(), "day")
    }, [formattedDate])

    const colorOfDay = useMemo(() => {
        if (date.isCurrentDay) return "common.white"
        if (isAfterToday) return "text.primary"
        return "text.disabled"
    }, [date, isAfterToday])

    const handleCreatePost = useCallback(() => {
        createPost(true, dayjs(formattedDate).format("YYYY-MM-DD"))
        flushTempPost()
    }, [createPost, formattedDate, flushTempPost])

    const isNotEmptyBloc = useMemo(() => getData(events[formattedDate]), [events, date, getData])

    return (
        <Stack className="bloc-date" key={date.day} gap={1} data-testid={date.isCurrentMonth ? date.day : null}>
            {date.isCurrentMonth && (
                <Stack
                    flexGrow={"1"}
                    justifyContent={isMobile ? "center" : "initial"}
                    paddingY={isMobile ? 3 : "initial"}
                    paddingX={isMobile ? 2 : "initial"}
                    gap={1}
                    onMouseOver={() => handleShowIconAddPost(true)}
                    onMouseLeave={() => handleShowIconAddPost(false)}
                    onClick={() => !isNotEmptyBloc && isAfterToday && handleCreatePost()}
                >
                    <Stack
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        onClick={() => isAfterToday && handleCreatePost()}
                    >
                        <Typography
                            variant="body1"
                            fontSize={12}
                            className="date-label"
                            color={colorOfDay}
                            sx={{
                                backgroundColor: date.isCurrentDay ? "primary.main" : "transparent",
                            }}
                        >
                            {date.day}
                        </Typography>
                        {showIconAddPost && isAfterToday && (
                            <Button
                                variant="contained"
                                className="btn-add-post"
                                onClick={handleCreatePost}
                                aria-label="add post"
                            >
                                <Icon name="plus" />
                            </Button>
                        )}
                    </Stack>
                    {getData(events[formattedDate])}
                </Stack>
            )}
        </Stack>
    )
}
